import { WebReportEvent, ResourceErrorReport } from '@slardar/sdk-web';
import BasePlugin from './base-plugin';

const REPORT_RESOURCE_TYPE_LIST = ['link', 'script'];
const REG_JS_SCRIPT = /.js/;
const REG_CSS_SCRIPT = /.css/;
export default class ResourceErrorPlugin extends BasePlugin {
  handle(event: ResourceErrorReport) {
    const { payload } = event;
    if (
      REPORT_RESOURCE_TYPE_LIST.includes(payload.type) &&
      (REG_JS_SCRIPT.test(payload.url) || REG_CSS_SCRIPT.test(payload.url))
    ) {
      return event;
    }
    return false;
  }

  shouldHandle(event: WebReportEvent): event is ResourceErrorReport {
    return event.ev_type === 'resource_error';
  }
}
